import { useState, useRef, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const RichTextEditor = ({ item }) => {
  const [content, setContent] = useState(item.defaultValue || " ");
  const [preProcess, setPreProcess] = useState(false);

  const preProcessRef = useRef(preProcess);
  useEffect(() => {
    preProcessRef.current = preProcess;
  }, [preProcess]);

  const handleImageUpload = async (blobInfo, progress) => {
    const formData = new FormData();
    formData.append("image", blobInfo.blob(), blobInfo.filename());

    try {
      console.log("Using preProcess:", preProcessRef.current);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}api/v1/image-upload?process=${preProcessRef.current}`,
        {
          method: "POST",
          body: formData
        }
      );

      const result = await res.json();

      if (res.ok && result.filename) {
        return `${process.env.REACT_APP_API_URL}images/${result.filename}`;
      } else {
        throw new Error(result.error || "Upload failed");
      }
    } catch (err) {
      console.error("Image upload error:", err);
      throw err;
    }
  };

  return (
    <div className="w-full">
      {/* Header with label and checkbox */}
      <div className="flex justify-between items-center">
        <label htmlFor={item.name} className="label capitalize">
          <span className="text-md font-semibold">
            {item?.label}
          </span>
        </label>

        <div className="flex items-center text-sm">
          Image Process
          <input
            type="checkbox"
            checked={preProcess}
            onChange={(e) => setPreProcess(e.target.checked)}
            className="ml-2 w-4 h-4 accent-white cursor-pointer"
          />
        </div>
      </div>

      {/* Editor */}
      <div className='pt-2'>
        <Editor
          apiKey={process.env.REACT_APP_TINY_MCE_API_KEY}
          textareaName={item.name}
          value={content}
          onEditorChange={(newText) => setContent(newText)}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
              "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
              "insertdatetime", "media", "table", "help", "wordcount"
            ],
            toolbar:
              "undo redo | blocks fontsizeselect | " +
              "bold italic underline strikethrough blockquote | " +
              "forecolor backcolor | link image media table | " +
              "alignleft aligncenter alignright alignjustify | " +
              "bullist numlist outdent indent | removeformat | code fullscreen preview | help",
            font_size_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",

            image_title: true,
            automatic_uploads: true,
            file_picker_types: 'image',

            // Now always uses latest value from ref
            images_upload_handler: handleImageUpload
          }}
        />
      </div>
    </div>
  );
};

export default RichTextEditor;






// import { useEffect, useState } from 'react';
// import { Editor } from '@tinymce/tinymce-react';




// const RichTextEditor = ({ item }) => {
//     const [content, setContent] = useState(item.defaultValue || " ");

//     return (
//         <div className="w-full">
//             <label htmlFor={item.name} className="label capitalize">
//                 <span className="text-md font-semibold">
//                     {item?.label}
//                 </span>
//             </label>
//             <div className='pt-2'>
//                 <Editor
//                     apiKey={process.env.REACT_APP_TINY_MCE_API_KEY}
//                     textareaName={item.name}
//                     value={content}
//                     onEditorChange={(newText) => setContent(newText)}
//                     init={{
//                         height: 500,
//                         menubar: false,
//                         plugins: [
//                             "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
//                             "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
//                             "insertdatetime", "media", "table", "help", "wordcount"
//                         ],
//                         toolbar:
//                             "undo redo | blocks fontsizeselect | " +
//                             "bold italic underline strikethrough blockquote | " +
//                             "forecolor backcolor | link image media table | " +
//                             "alignleft aligncenter alignright alignjustify | " +
//                             "bullist numlist outdent indent | removeformat | code fullscreen preview | help",
//                         font_size_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt",
//                         content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }"
//                     }}
//                 />
//             </div>
//         </div>
//     );
// };


// export default RichTextEditor